export default {
  // 搜索區
  templateName: '模板名稱',
  templateNamePlaceholder: '請輸入模板名稱',
  productName: '產品名稱',
  productNamePlaceholder: '請輸入產品名稱',
  // 表格列
  colTemplateName: '模板名稱',
  colRelatedProduct: '關聯產品',
  colIsDefault: '預設模板',
  // 預設模板
  defaultOn: '開啟',
  defaultOff: '關閉',
  defaultOnSuccess: '已設為預設模板',
  defaultOffSuccess: '已關閉預設模板',
  defaultChangeFailed: '預設模板狀態更新失敗',
  // 操作
  editTemplate: '修改模板',
  addProduct: '添加產品',
  // 添加產品彈窗
  addProductTitle: '添加關聯產品',
  selectProduct: '選擇產品',
  selectProductPlaceholder: '請選擇產品',
  productRequired: '請選擇產品',
  addProductSuccess: '產品添加成功',
  addProductFailed: '產品添加失敗',
  // 修改模板
  editTemplateSuccess: '模板修改成功',
  editTemplateFailed: '模板修改失敗',
  // 查看產品彈窗
  viewProductsTitle: '關聯產品列表',
  colProductId: '產品ID',
  colProductName: '產品名稱',
  // 空狀態
  emptyText: '暫無模板數據',
};
